export const environment = {
  production: false,
  api: 'https://api-ladder.eagledigital.com.br:7443',
  ws: 'https://api-ladder.eagledigital.com.br:7443',
  storageUrl: 'https://api-ladder.eagledigital.com.br:7443/api/uploads/',
};
